/* eslint-disable fp/no-unused-expression */
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { Auth0Provider } from '@auth0/auth0-react'
import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6'

import { store } from 'src/store/store'
import App from './App'
import theme from './theme'
import './index.css'

const apiDomain = import.meta.env.VITE_BACKEND_URL || ''
const apiDomainPattern = new RegExp(
  apiDomain.replace('https://', '').replace('http://', ''),
)

const frontendDomain = import.meta.env.VITE_FRONTEND_URL || ''
const frontendDomainPattern = new RegExp(
  frontendDomain.replace('https://', '').replace('http://', ''),
)

datadogRum.init({
  version: '1.0.0',
  applicationId: 'af9c22bb-01d9-4ddc-83fd-485adc9f1b32',
  clientToken: 'pub4573e7c8afc298a851d42d5bb4e5ba2d',
  site: 'datadoghq.com',
  service: 'react-client',
  env:
    (import.meta.env.VITE_FRONTEND_URL || 'test').includes('test') ||
    import.meta.env.VITE_FRONTEND_URL.includes('localhost')
      ? 'test'
      : 'prod',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 25,
  trackResources: true,
  trackUserInteractions: true,
  defaultPrivacyLevel: 'allow',
  allowedTracingUrls: [apiDomainPattern, frontendDomainPattern],
  plugins: [reactPlugin({ router: true })],
})

let router = createBrowserRouter([
  {
    path: '/*',
    element: <App />,
  },
])

let container = document.getElementById('root')
let root = createRoot(container as Element | DocumentFragment)
// eslint-disable-next-line fp/no-unused-expression
root.render(
  // <StrictMode>
  <Auth0Provider
    domain={import.meta.env.VITE_AUTH0_DOMAIN}
    clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
    authorizationParams={{
      redirect_uri: `${window.location.origin}/self-paced`,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      scope: 'openid profile email',
    }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
  >
    <StyledEngineProvider injectFirst>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeProvider>
      </Provider>
    </StyledEngineProvider>
  </Auth0Provider>,
  // </StrictMode>,
)
